import * as actionTypes from "../actions/types";

const INITIAL_STATE = {
  menuLists: [],
  cartItems: [],
};

const cartReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.ORDER_MENU:
      return {
        ...state,
        menuLists: action.payload,
      };
    case actionTypes.FETCH_CART_ITEMS:
      return {
        ...state,
        cartItems: action.payload,
      };
    default:
      return state;
  }
};

export default cartReducers;
